import { render, staticRenderFns } from "./truncated-chip-list.vue?vue&type=template&id=6d8d70e0"
import script from "./truncated-chip-list.vue?vue&type=script&lang=js"
export * from "./truncated-chip-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports